import { render } from "./StationBoxDoorStateEvent.vue?vue&type=template&id=1c961bfc"
import script from "./StationBoxDoorStateEvent.vue?vue&type=script&lang=js"
export * from "./StationBoxDoorStateEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__